import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { SpinnerModule } from '../../components/spinner/spinner.module';
import { CustomControlsModule } from '../custom-controls/custom-controls.module';
import { CustomViewsModule } from '../custom-views/custom-views.module';
import { AddQuoteNoteModalComponent } from './components/add-quote-note-modal/add-quote-note-modal.component';
import { CarrierInstructionsModalComponent } from './components/carrier-instructions-modal/carrier-instructions-modal.component';
import { ConfigurableModalComponent } from './components/configurable-modal/configurable-modal.component';
import { OfferDiscountComponent } from './components/offer-discount/offer-discount.component';

@NgModule({
  declarations: [
    ConfigurableModalComponent,
    AddQuoteNoteModalComponent,
    CarrierInstructionsModalComponent,
    OfferDiscountComponent,
  ],
  exports: [
    ConfigurableModalComponent,
    AddQuoteNoteModalComponent,
    CarrierInstructionsModalComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    SpinnerModule,
    CustomViewsModule,
    CustomControlsModule,
  ],
})
export class CustomModalsModule { }
